var React = require('react');

function SingleLoop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 1V7H13","stroke":"#343434","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.9998 12.0001C18.7875 14.0061 17.9074 15.8825 16.5009 17.3284C15.0943 18.7742 13.2428 19.7057 11.2435 19.9732C9.24421 20.2408 7.21297 19.8289 5.47576 18.8037C3.73855 17.7786 2.39609 16.1995 1.66381 14.32C0.931526 12.4405 0.851873 10.3694 1.43763 8.43922C2.02339 6.509 3.2406 4.83152 4.89394 3.67595C6.54728 2.52038 8.54088 1.95373 10.5548 2.06692C12.5688 2.18012 14.4864 2.96659 15.9998 4.30015L18.9998 7.00014","stroke":"#343434","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SingleLoop.defaultProps = {"width":"20","height":"22","viewBox":"0 0 20 22","fill":"none"};

module.exports = SingleLoop;

SingleLoop.default = SingleLoop;
